import http from './http'
import qs from 'qs'

export default {
    all(query = {}) {
        return http.get(`ordenes?${qs.stringify(query)}`)
    },

    find(orden) {
        return http.get(`ordenes/${orden}`)
    },

    update(orden, payload) {
        return http.put(`ordenes/${orden}`, payload)
    }
}